import axios from "axios";
import * as types from "./mutation_types";

export const getItems = ({ commit }) => {
  commit(types.TRANSPORT_TOGGLE_LOADING);
  axios
    .get("/api/assise/transports")
    .then((response) => {
      commit(types.TRANSPORT_TOGGLE_LOADING);
      commit(types.TRANSPORT_SET_ITEMS, response.data);
    })
    .catch((e) => {
      commit(types.TRANSPORT_TOGGLE_LOADING);
      commit(types.TRANSPORT_SET_ERROR, e.message);
    });
};

export const reset = ({ commit }) => {
  commit(types.TRANSPORT_RESET);
};
